import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

export const PhotosLink = styled(Link)`
  text-align: center;
`;

export const PhotosLi = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid gray;
`;
